import React from "react";
import Career from "../components/Career/Career";

const JobsCareer = () => {
  return (
    <div>
      <Career />
    </div>
  );
};

export default JobsCareer;
